function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { validateError } from '@/services/services';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import axiosInstance from '@/services/api';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['tables_views']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091') //"https://crun-itc-dp-audience-intercorp-qmuzefzuga-uc.a.run.app"
  });
}
setupInterceptors(appApisGTW);
//setupInterceptors(axiosInstance)

var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId
  };
};
var CONTROLLER_NAME = '/tables_views';
var DOMAIN_ASSIGNMENTS = '/assignments';
var DOMAIN_REQUESTS = '/requests';
export default {
  setStatus: function setStatus(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.patch(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + DOMAIN_REQUESTS + '/set_status', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getAssignments: function getAssignments(data) {
    var _this = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAssignments)';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this.getAssignments(data);
      });
    });
  },
  getTablesDetails: function getTablesDetails(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);

    //tasks.lockScreen.lock()
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/get_detail_table', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      //tasks.lockScreen.unlock()
      return res.data;
    });
  },
  getListTagEntry: function getListTagEntry(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/list_tag_entry', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  updateTags: function updateTags(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/update_tags', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  syncTableSchema: function syncTableSchema(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/sync_table_schema', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  initApprovalFlow: function initApprovalFlow(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ASSIGNMENTS, "/init_approval_flow"), body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getRequestsByDate: function getRequestsByDate() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ASSIGNMENTS).concat(DOMAIN_REQUESTS, "/get_all"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getByOperator: function getByOperator(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ASSIGNMENTS, "/get_by_operator"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getApprovedColumns: function getApprovedColumns(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/approved_columns', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      console.log(res.data, 'res.data');
      return res.data;
    }).catch(function (err) {
      console.log(err, 'err');
    });
  },
  getTableMetadataTag: function getTableMetadataTag(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/table_metadata_tag', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getListTagEntryPaginated: function getListTagEntryPaginated(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/list_tag_entry_paginated', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  }
};